const getDiff = (value, mark) => Math.abs(mark - value);
export const getClosestMark = (value, marks, getMarkValue) => marks.reduce((accResult, mark) => {
    const diff = getDiff(value, getMarkValue(mark));
    if (diff < accResult.lowestDiff) {
        return {
            lowestDiff: diff,
            mark,
        };
    }
    return accResult;
}, {
    lowestDiff: getDiff(value, getMarkValue(marks[0])),
    mark: marks[0],
});
